/**
 * Helper utilities for the search widget
 */

/**
 * Normalize font-family values saved as ("Manrope", sans-serif) or Manrope, sans-serif
 */
export function normalizeFF(v) {
  if (!v) return "inherit";
  let s = String(v).trim();
  if (s.startsWith("(") && s.endsWith(")")) s = s.slice(1, -1).trim();
  return s;
}

/**
 * Parse JSON string or return object as-is
 */
export function parseMaybe(strOrObj) {
  if (!strOrObj) return null;
  if (typeof strOrObj === "object") return strOrObj;
  try {
    return JSON.parse(String(strOrObj));
  } catch {
    return null;
  }
}

/**
 * Convert Font Awesome 6 syntax to Font Awesome 5 (for compatibility)
 */
export function normalizeFAFamily(family) {
  if (family === "fa-solid") return "fas";
  if (family === "fa-regular") return "far";
  if (family === "fa-brands") return "fab";
  // If already FA5 format, return as is
  if (family === "fas" || family === "far" || family === "fab") return family;
  // Default to solid
  return "fas";
}

/**
 * Helper to read data attribute and convert to appropriate type
 */
export function readDataAttr(el, attrName, defaultValue) {
  if (!el) return defaultValue;
  const val = el.getAttribute(attrName);
  if (val === null || val === undefined) return defaultValue;

  // Convert to appropriate type based on default value
  if (typeof defaultValue === "number") {
    const num = parseFloat(val);
    return isNaN(num) ? defaultValue : num;
  }
  if (typeof defaultValue === "boolean") {
    return val === "true";
  }
  return val;
}
